import { render, staticRenderFns } from "./DamageCategories.vue?vue&type=template&id=0b06bf98&scoped=true"
import script from "./DamageCategories.vue?vue&type=script&lang=js"
export * from "./DamageCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06bf98",
  null
  
)

export default component.exports